import { render, staticRenderFns } from "./OfferEdit.vue?vue&type=template&id=2544762f&scoped=true"
import script from "./OfferEdit.vue?vue&type=script&lang=ts"
export * from "./OfferEdit.vue?vue&type=script&lang=ts"
import style0 from "./OfferEdit.vue?vue&type=style&index=0&id=2544762f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2544762f",
  null
  
)

export default component.exports